<div class="" matSnackBarLabel>
  <div><strong>{{ snackbarData.summary }}</strong></div>
  @if (snackbarData.detail) {
    <div>{{ snackbarData.detail }}</div>
  }
</div>
<span matSnackBarActions>
  <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">X</button>
</span>
